import React, {memo} from 'react';

import {SIZE, INTERACTION, STEPS_STATUS, BUTTON_VARIANT} from "utils";
import {useGetUserItemOrdersQuery} from "store/Bazaar/bazaar.api";
import {useActiveItemContext} from "./useActiveItemContext";
import {useModalsContext} from "layouts";

import BazaarCurrentItemAccordionBlock from "./BazaarCurrentItemAccordionBlock";
import {ButtonV2} from "components/atoms";

const BazaarCurrentItemInteractionToolsSell = ({totalOwnedNFT}) => {
    const {data, chainId, network,handleAuthAndWalletChecks} = useActiveItemContext()
    const {setCurrentModal} = useModalsContext()

    const openModal = (status) => {
        if (!handleAuthAndWalletChecks()) return;

        const itemInfo = {
            network,
            chainId,
            owned: totalOwnedNFT,
            sku: data.inventory.sku,
            name: data.inventory.name,
            tokenId: data?.details.token_id,
        }

        setCurrentModal(prevState => ({...prevState, data: itemInfo, status}))
    }

    return (
        <div className="bazaar_current-item_interaction-tools_btn-group_tabs-content_sell">
            <div className="bazaar_current-item_interaction-tools_btn-group_tabs-content_sell_btns">
                <ButtonV2
                    size={SIZE.MEDIUM}
                    variant={BUTTON_VARIANT.RED}
                    onClick={() => openModal(STEPS_STATUS.LIST_ITEM)}
                >
                    listForSale
                </ButtonV2>
                <ButtonV2
                    size={SIZE.MEDIUM}
                    onClick={() => openModal(STEPS_STATUS.NFT_TRANSFER)}
                >
                    send
                </ButtonV2>
            </div>
            <BazaarCurrentItemAccordionBlock
                totalOwnedNFT={totalOwnedNFT}
                interaction={INTERACTION.SELL}
                queryHook={useGetUserItemOrdersQuery}
            />
        </div>
    )
}

export default memo(BazaarCurrentItemInteractionToolsSell)